import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as z from 'zod';
import { ProgressLayout } from '../../../components/layouts/progress-layout';
import { PatchInviteForm } from '../../../components/patch-invite-form';
import { Input } from '../../../components/ui/input';
import { Select } from '../../../components/ui/select';
import { PHONE_NUMBER_REGEX } from '../../../constants/misc';

export const schema = z.object({
  fullName: z.string().nonempty(),
  relationship: z.string().nonempty(),
  mobileNumber: z.string().trim().regex(PHONE_NUMBER_REGEX),
});

function extractDefaults({ emergency }) {
  return {
    fullName: emergency?.fullName ?? '',
    relationship: emergency?.relationship ?? '',
    mobileNumber: emergency?.mobileNumber ?? '',
  };
}

function transformValues(values) {
  return {
    emergency: { ...values },
  };
}

export function Emergency(props) {
  const { t } = useTranslation('page.details');
  const relationshipOptions = useMemo(
    () => [
      { id: 'parent', label: t('emergency.select.parent') },
      { id: 'spouse', label: t('emergency.select.spouse') },
      { id: 'child', label: t('emergency.select.child') },
      { id: 'friend', label: t('emergency.select.friend') },
      { id: 'other', label: t('emergency.select.other') },
    ],
    [t],
  );

  return (
    <PatchInviteForm
      extractDefaults={extractDefaults}
      transformValues={transformValues}
      schema={schema}
      nextPath={props.next.path}
    >
      <ProgressLayout {...props}>
        <h1 className="title">{t('emergency.title')}</h1>
        <p className="mb-5">{t('emergency.text')}</p>
        <div className="space-y-5">
          <Input name="fullName" label={t(`emergency.fullName`)} />
          <Select
            name="relationship"
            options={relationshipOptions}
            label={t('emergency.relationship')}
          />
          <Input name="mobileNumber" type="tel" label={t(`emergency.mobileNumber`)} />
        </div>
        <p className="mt-5 italic">{t('emergency.footnote')}</p>
      </ProgressLayout>
    </PatchInviteForm>
  );
}
